// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectionFilter_container__d0o_f","title":"CollectionFilter_title____3Q5"};